import { parse, format } from "date-fns";

const useUtils = () => {
  const getFilePathWithBackendUrl = (path: any): string => {
    if (typeof path !== "string") {
      return "";
    }

    if (path.includes("http")) {
      return path;
    } else {
      return process.env.REACT_APP_MEDIA_BASE_URL + path;
    }
  };

  const createQuery = (params: any = {}): string => {
    let query = "";
    let i = 0;
    for (let key in params) {
      query += `${i === 0 ? "?" : "&"}${key}=${params[key]}`;
      i++;
    }
    return query;
  };

  const downloadFileByUrl = (url: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const getAge = (dob: string): number => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }

  const getQueryParams: any = () => {
    return window.location.search
      .replace(/^\?/, "")
      .split("&")
      .reduce((obj, str) => {
        if (!str) return obj;
        const pair = str.split("=");
        return { ...obj, [pair[0]]: pair[1] };
      }, {});
  };

  const getDateTime = (dateString: string) => {
    if(dateString){
      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        month: "long",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }else{
      return dateString;
    }
  }

  const formatDateOfBirth = (dateString: string | undefined): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  }

  // Format date from "dd MMMM, yyyy" to "MMM dd, yyyy" (e.g., "Nov 29, 2025")
  const formatDateToMMDDYYYY = (dateString: string): string => {
    if (!dateString) return dateString;
    try {
      // Parse "dd MMMM, yyyy" format (e.g., "15 January, 2024")
      const parsedDate = parse(dateString, "dd MMMM, yyyy", new Date());
      // Format to MMM dd, yyyy (e.g., "Nov 29, 2025")
      return format(parsedDate, "MMM dd, yyyy");
    } catch (error) {
      // If parsing fails, try parsing as ISO date string or return original
      try {
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return format(date, "MMM dd, yyyy");
        }
      } catch (e) {
        // Return original if all parsing fails
      }
      return dateString;
    }
  };

  return {
    getFilePathWithBackendUrl,
    createQuery,
    getAge,
    getQueryParams,
    downloadFileByUrl,
    getDateTime,
    formatDateOfBirth,
    formatDateToMMDDYYYY
  }
}

export default useUtils;